// extracted by mini-css-extract-plugin
export default {"container":"BRn1N","gradient":"aq3aw","content":"vZosj","title":"J8WSX","subtitle":"bzBF2"};